import React, { useMemo, useState } from 'react';
import { safeHref } from '../../utils/common/safe-url';
import ReactPlayer from 'react-player';

interface Hotspot { label: string; url: string; start: number; end: number }

/**
 * Player video + lớp phủ "thẻ mua sắm" tương tác (Interactive Hotspots / Shoppertainment).
 * Hiện nút bấm được (link sản phẩm/gói VIP) chồng lên video trong khoảng [start,end] khi đang phát.
 * Không có hotspot → hoạt động y như ReactPlayer thường (additive, không đổi hành vi post khác).
 */
export const VideoWithShopHotspots: React.FC<{
  url?: string;
  hotspotsJson?: string | null;
  config?: any;
  width?: string | number;
  playing?: boolean;
}> = ({ url, hotspotsJson, config, width, playing = false }) => {
  const [t, setT] = useState(0);
  const hotspots = useMemo<Hotspot[]>(() => {
    if (!hotspotsJson) return [];
    try {
      const a = JSON.parse(hotspotsJson);
      return Array.isArray(a) ? a : [];
    } catch {
      return [];
    }
  }, [hotspotsJson]);

  const active = hotspots.filter((h) => h?.url && h?.label && t >= (h.start || 0) && t <= (h.end || 0));

  return (
    <div className="relative">
      <ReactPlayer
        playing={playing}
        url={url}
        loop
        controls
        width={width}
        config={config}
        onProgress={(s) => setT(s.playedSeconds)}
        progressInterval={500}
      />
      {active.length > 0 && (
        <div className="pointer-events-none absolute left-0 right-0 bottom-14 flex flex-wrap justify-center gap-2 px-3">
          {active.map((h, i) => (
            <a
              key={i}
              href={safeHref(h.url)}
              target="_blank"
              rel="noreferrer"
              className="pointer-events-auto rounded-full bg-[#0284c7] px-4 py-1.5 text-sm font-semibold text-white shadow-lg hover:brightness-110"
            >
              🛒 {h.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
